import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { NewsletterUnsubscribeFacade } from './newsletter-unsubscribe.facade';

@Injectable({
  providedIn: 'root',
})
export class NewsletterUnsubscribeGuard {
  constructor(private newsletterUnsubscribeFacade: NewsletterUnsubscribeFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { token },
    } = route;
    return checkStoreState(this.newsletterUnsubscribeFacade, token);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.newsletterUnsubscribeFacade);
  }
}
